import React, { useState } from 'react';

export default function FileDropZone({
  disabled = false,
  onFiles,
  onClick,
  className = '',
  activeClassName = '',
  children,
}) {
  const [over, setOver] = useState(false);

  const stop = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div
      className={`${className} ${over && !disabled ? activeClassName : ''}`.trim()}
      onClick={onClick}
      onDragEnter={(event) => {
        stop(event);
        if (!disabled) setOver(true);
      }}
      onDragOver={(event) => {
        stop(event);
        if (!disabled) setOver(true);
      }}
      onDragLeave={(event) => {
        stop(event);
        setOver(false);
      }}
      onDrop={(event) => {
        stop(event);
        setOver(false);
        if (disabled) return;
        onFiles?.(event.dataTransfer.files);
      }}
    >
      {children}
    </div>
  );
}
